import NewsItemList from '../../../../component/NewsCardList'

export default NewsItemList
